import React from "react";
import e from "./noPage.module.css";
import { Link } from "react-router-dom";

export default function NoPage() {
  return (
    <div className={e.container}>
      <div className={e.errorBK}>
        <div className={e.centerHW}>
          <Link to="/home" className={e.btn01}>
            GO BACK
          </Link>
        </div>
      </div>
    </div>
  );
}
